// extracted by mini-css-extract-plugin
export default {"container":"SquareRadio_container__ppcHN","outerSquare":"SquareRadio_outerSquare__YnSPy","disabled":"SquareRadio_disabled__VJYPc","labelText":"SquareRadio_labelText__EkswJ"};